var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showShortForm)?_c('QShortReadonly',_vm._b({},'QShortReadonly',_vm.$props,false)):_c('QLongReadonly',_vm._b({},'QLongReadonly',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }